import type { EntityKey } from '@/generated/entity-config'
import type { EntityFormsOverride } from './entity-forms'

export type EntityFormConfigOverride = {
	entity: EntityKey
	override: EntityFormsOverride
}

type EntityFormConfigOverrideModule = {
	entityFormConfigOverride?: EntityFormConfigOverride
}

const overrideModules = import.meta.glob<EntityFormConfigOverrideModule>(
	'../form-config-overrides/*.ts',
	{ eager: true },
)

export const entityFormConfigOverrides: Partial<
	Record<EntityKey, EntityFormsOverride>
> = Object.values(overrideModules).reduce(
	(accumulator, module) => {
		const override = module.entityFormConfigOverride
		if (!override) {
			return accumulator
		}

		accumulator[override.entity] = override.override
		return accumulator
	},
	{} as Partial<Record<EntityKey, EntityFormsOverride>>,
)
